exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.list-block {\n  padding: 0px 0px 0px 0px;\n  margin: 0px 0px 0px 0px;\n}\n.statusLabel {\n  color: #878787;\n  font-size: 11px;\n  float: left;\n  padding-top: 6px;\n}\n.timeLabel {\n  color: #878787;\n  float: right;\n}\n.dashboardActionMontant {\n  color: #000000;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-121e9485","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/dashboard/dashboardComponents/DashboardList.vue
// module id = 1531
// module chunks = 2